import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "effect-control-panel-toggle" }

import LockIcon from '@/assets/LockWithCircleIcon.svg'
import UnlockIcon from '@/assets/UnlockIcon.svg'
import { toRefs } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EffectsControlPanelToggle',
  props: {
    isLocked: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isLocked: boolean
};



const {
  isLocked
} = toRefs(props)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isLocked))
      ? (_openBlock(), _createBlock(_unref(LockIcon), { key: 0 }))
      : (_openBlock(), _createBlock(_unref(UnlockIcon), { key: 1 }))
  ]))
}
}

})